import {css} from 'aphrodite';
import React from 'react';

import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import Menu from 'ui-library/menus/Menu';

import {styles} from './WorksheetNavigationComponent';

export default function DisabledMethodAndWorksheetDropdowns({
  worksheetName,
  methodName,
}: {
  worksheetName: string;
  methodName: string;
}): JSX.Element {
  return (
    <div className={css(styles.worksheetNavigationComponent)}>
      <SelectDropdown
        disabled={true}
        displayName={methodName}
        menu={<Menu height={Menu.HEIGHTS.SMALL} width={Menu.WIDTHS.SMALL} />}
        className={css(styles.selectMethodDropdown)}
      />
      <BenchlingIcon icon="chevron-right" className={css(styles.chevron)} />
      <SelectDropdown
        disabled={true}
        displayName={worksheetName}
        menu={<Menu height={Menu.HEIGHTS.SMALL} width={Menu.WIDTHS.FULL} />}
        className={css(styles.selectWorksheetDropdown)}
        shouldEllipsize={true}
      />
    </div>
  );
}
